import React from 'react';
import { Card, CardTitle, Option, Input, withGrid, CardContent, Select, TextButton } from '../../../Components';
import { ProfessorModel } from '../../../Store';
import { observer } from 'mobx-react';
import { ValidationError } from '../../../Store';
import styled from 'styled-components';
import { media } from '../../../Themes';

interface ISuplentesCardProps extends React.InputHTMLAttributes<any> {
  professores: ProfessorModel[];
  suplentes: ProfessorModel[];
  handleSuplenteSelectChange: (event: React.ChangeEvent<HTMLSelectElement>, idx: number) => any;
  addSuplente: () => void;
  removerSuplente: (idx: number) => void;
  validation: ValidationError<ProfessorModel[]>;
  disabled?: boolean;
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const StyledTextButton = styled(TextButton) <any>`
    grid-column: ${p => p.gridColumn}
    margin: 0;
    font-size: 1rem

`;

const SelectGrid = InputGrid.withComponent(Select);

@observer
export default class ProfessorCard extends React.Component<ISuplentesCardProps> {
  cardRef: React.RefObject<HTMLDivElement>;

  constructor(props: ISuplentesCardProps) {
    super(props);
    this.cardRef = React.createRef();
  }

  render() {
    const {
      professores,
      suplentes,
      validation,
      addSuplente,
      removerSuplente,
      disabled,
      handleSuplenteSelectChange
    } = this.props;

    const Options = <>
      <Option value={0}> Selecione... </Option>
      {professores.filter(p => p.ativoBanca == true).map(p => (
        <Option value={p.id} key={p.id}>
          {p.nome}
        </Option>
      ))}
    </>;

    return (
      <Card ref={this.cardRef}>
        <CardTitle>Suplentes</CardTitle>
        <CardContentGrid>
          {suplentes.map((s, i) =>
            <>
              <SelectGrid
                key={i}
                gridColumn={i > 0 ? '1/11' : '1/13'}
                name='nome'
                label={`Suplente ${i + 1}`}
                type='text'
                value={(professores.find(p => p.nome === s.nome)
                  && professores.find(p => p.nome === s.nome)!.id) || 0}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleSuplenteSelectChange(e, i)}
                disabled={disabled}
                hasError={validation && validation[i] && validation[i]!.nome}
                errorMessage={validation && validation[i] && validation[i]!.nome}
              >
                {Options}
              </SelectGrid>
              {i > 0 &&
                <StyledTextButton
                  gridColumn='11/13'
                  color='errorColor'
                  onClick={() => removerSuplente(i)}
                >
                  Excluir
                </StyledTextButton>
              }
            </>
          )}
          {!disabled &&
            <StyledTextButton
              gridColumn='1/3'
              color='secondaryColor'
              onClick={addSuplente}
            >
              + Adicionar
            </StyledTextButton>}
        </CardContentGrid>
      </Card>
    );
  }
}
